"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { twMerge } from "tailwind-merge"
import clsx from "clsx"

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={twMerge(clsx(
      "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className
    ))}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label } 
